import { createStore } from "vuex";
import { login,submitAppInfo,submitAppInfo2,bury2,buryConfig } from '@api/index.js'
import { setToken, setTokenFromStorage, removeToken, removeTokenFromStorage, setPhone,setPhoneFromStorage} from '../utils/tool'
import dayjs from "dayjs";
 const store = createStore({
    state () {
        return {
            token : '',
            toast_state: false,
            toast_txt: '',
            phone: "",
            isApp:false,
            bury:{},
            buryCache:[],
            buryConfig:{}
        }
    },
    getters: {
        token (state) {
            return state.token
        },
        toast_txt (state) {
            return state.toast_txt
        }
    },
    mutations: {
        setBuryConfig(state, dict) {
            state.buryConfig = dict
        },
        setBury(state, newBury) {
            state.bury = newBury
            window.localStorage.setItem("bury", JSON.stringify(state.bury))
            console.log(JSON.stringify(state.bury))
        },
        setburyDelay(state, newBury) {
            state.buryCache.push(newBury)
            console.log(JSON.stringify(state.buryCache))
            window.localStorage.setItem("bury", JSON.stringify(state.buryCache))
        },
        setToken(state, token) {
            state.token = token
        },
        setToast(state, show) {
            state.toast_state = show
        },
        setToastTxt(state, txt) {
            state.toast_txt = txt
        },
        setApp(state, isApp) {
            state.isApp = isApp
        },
        clearToken(state) {
            state.token = ''
            removeToken()
            removeTokenFromStorage()
        },
        setPhone(state, phone) {
            state.phone = phone
            setPhone(phone)
        },
        clearBury(state) {
            state.bury = {}
        },  
        clearBuryCache (state) {
            state.buryCache = []
        }     
    },
    actions: {
        async fetchConfig({ commit }) {
            const config = await buryConfig();   
            // config.data = {
            //     "home_page": {
            //         "page": [
            //             {
            //                 "id": 2,
            //                 "clientId": 1,
            //                 "clientType": "ios-h5",
            //                 "functionModule": "首页",
            //                 "pageCode": "home_page",
            //                 "pageDes": "首页",
            //                 "eventId": "home_page_app_button_click",
            //                 "eventDes": "首页点击申请按钮",
            //                 "eventType": null,
            //                 "dataItem": null,
            //                 "dataItemType": null,
            //                 "dataItemCode": null,
            //                 "dataItemDes": null,
            //                 "riskControlFields": null,
            //                 "createTime": null,
            //                 "updateTime": null
            //             },
            //             {
            //                 "id": 4,
            //                 "clientId": 1,
            //                 "clientType": "ios-h5",
            //                 "functionModule": "首页",
            //                 "pageCode": "home_page",
            //                 "pageDes": "首页",
            //                 "eventId": "home_page_home_button_click",
            //                 "eventDes": "首页点击",
            //                 "eventType": null,
            //                 "dataItem": null,
            //                 "dataItemType": null,
            //                 "dataItemCode": null,
            //                 "dataItemDes": null,
            //                 "riskControlFields": null,
            //                 "createTime": null,
            //                 "updateTime": null
            //             },
            //             {
            //                 "id": 5,
            //                 "clientId": 1,
            //                 "clientType": "ios-h5",
            //                 "functionModule": "首页",
            //                 "pageCode": "home_page",
            //                 "pageDes": "首页",
            //                 "eventId": "home_page_orders_button_click",
            //                 "eventDes": "取消按钮",
            //                 "eventType": null,
            //                 "dataItem": null,
            //                 "dataItemType": null,
            //                 "dataItemCode": null,
            //                 "dataItemDes": null,
            //                 "riskControlFields": null,
            //                 "createTime": null,
            //                 "updateTime": null
            //             },
            //             {
            //                 "id": 6,
            //                 "clientId": 1,
            //                 "clientType": "ios-h5",
            //                 "functionModule": "首页",
            //                 "pageCode": "home_page",
            //                 "pageDes": "首页",
            //                 "eventId": "home_page_account_button_click",
            //                 "eventDes": "进入页面异常",
            //                 "eventType": null,
            //                 "dataItem": null,
            //                 "dataItemType": null,
            //                 "dataItemCode": null,
            //                 "dataItemDes": null,
            //                 "riskControlFields": null,
            //                 "createTime": null,
            //                 "updateTime": null
            //             }
            //         ]
            //     },
            //     "apply_page": {
            //         "walletAccount": {
            //             "focus": "apply_page_focus_input_walletAccount",
            //             "enter": "apply_page_enter_input_walletAccount",
            //             "complete": "apply_page_complete_input_walletAccount",
            //             "validate": "apply_page_validate_error_walletAccount"
            //         },
            //         "page": [
            //             {
            //                 "id": 150,
            //                 "clientId": 1,
            //                 "clientType": "ios-h5",
            //                 "functionModule": "订单模块",
            //                 "pageCode": "apply_page",
            //                 "pageDes": "订单申请页面",
            //                 "eventId": "apply_page_view",
            //                 "eventDes": "进入页面",
            //                 "eventType": null,
            //                 "dataItem": null,
            //                 "dataItemType": null,
            //                 "dataItemCode": null,
            //                 "dataItemDes": null,
            //                 "riskControlFields": null,
            //                 "createTime": null,
            //                 "updateTime": null
            //             },
            //             {
            //                 "id": 151,
            //                 "clientId": 1,
            //                 "clientType": "ios-h5",
            //                 "functionModule": "订单模块",
            //                 "pageCode": "apply_page",
            //                 "pageDes": "订单申请页面",
            //                 "eventId": "apply_page_enter_button_click",
            //                 "eventDes": "页面提交按钮",
            //                 "eventType": null,
            //                 "dataItem": null,
            //                 "dataItemType": null,
            //                 "dataItemCode": null,
            //                 "dataItemDes": null,
            //                 "riskControlFields": null,
            //                 "createTime": null,
            //                 "updateTime": null
            //             },
            //             {
            //                 "id": 152,
            //                 "clientId": 1,
            //                 "clientType": "ios-h5",
            //                 "functionModule": "订单模块",
            //                 "pageCode": "apply_page",
            //                 "pageDes": "订单申请页面",
            //                 "eventId": "apply_page_exit_page_tech",
            //                 "eventDes": "退出页面",
            //                 "eventType": null,
            //                 "dataItem": null,
            //                 "dataItemType": null,
            //                 "dataItemCode": null,
            //                 "dataItemDes": null,
            //                 "riskControlFields": null,
            //                 "createTime": null,
            //                 "updateTime": null
            //             },
            //             {
            //                 "id": 153,
            //                 "clientId": 1,
            //                 "clientType": "ios-h5",
            //                 "functionModule": "订单模块",
            //                 "pageCode": "apply_page",
            //                 "pageDes": "订单申请页面",
            //                 "eventId": "apply_page_enter_button_click_success",
            //                 "eventDes": "页面提交保存成功",
            //                 "eventType": null,
            //                 "dataItem": null,
            //                 "dataItemType": null,
            //                 "dataItemCode": "",
            //                 "dataItemDes": "",
            //                 "riskControlFields": null,
            //                 "createTime": null,
            //                 "updateTime": null
            //             }
            //         ],
            //         "walletCode": {
            //             "focus": "apply_page_focus_input_walletCode",
            //             "enter": "apply_page_enter_input_walletCode",
            //             "complete": "apply_page_complete_input_walletCode",
            //             "validate": "apply_page_validate_error_walletCode"
            //         }
            //     },
            //     "contact_page": {
            //         "twoName": {
            //             "focus": "contact_page_focus_input_twoName",
            //             "enter": "contact_page_enter_input_twoName",
            //             "complete": "contact_page_complete_input_twoName",
            //             "validate": "contact_page_validate_error_twoName"
            //         },
            //         "thirdMobile": {
            //             "focus": "contact_page_focus_input_thirdMobile",
            //             "enter": "contact_page_enter_input_thirdMobile",
            //             "complete": "contact_page_complete_input_thirdMobile",
            //             "validate": "contact_page_validate_error_thirdMobile"
            //         },
            //         "oneRelation": {
            //             "focus": "contact_page_focus_select_oneRelation",
            //             "enter": "contact_page_enter_select_oneRelation",
            //             "complete": "contact_page_complete_select_oneRelation",
            //             "validate": "contact_page_validate_error_oneRelation"
            //         },
            //         "thirdRelation": {
            //             "focus": "contact_page_focus_select_thirdRelation",
            //             "enter": "contact_page_enter_select_thirdRelation",
            //             "complete": "contact_page_complete_select_thirdRelation",
            //             "validate": "contact_page_validate_error_thirdRelation"
            //         },
            //         "twoRelation": {
            //             "focus": "contact_page_focus_select_twoRelation",
            //             "enter": "contact_page_enter_select_twoRelation",
            //             "complete": "contact_page_complete_select_twoRelation",
            //             "validate": "contact_page_validate_error_twoRelation"
            //         },
            //         "oneMobile": {
            //             "focus": "contact_page_focus_input_oneMobile",
            //             "enter": "contact_page_enter_input_oneMobile",
            //             "complete": "contact_page_complete_input_oneMobile",
            //             "validate": "contact_page_validate_error_oneMobile"
            //         },
            //         "page": [
            //             {
            //                 "id": 146,
            //                 "clientId": 1,
            //                 "clientType": "ios-h5",
            //                 "functionModule": "认证模块",
            //                 "pageCode": "contact_page",
            //                 "pageDes": "contact认证",
            //                 "eventId": "contact_page_view",
            //                 "eventDes": "进入页面",
            //                 "eventType": null,
            //                 "dataItem": null,
            //                 "dataItemType": null,
            //                 "dataItemCode": null,
            //                 "dataItemDes": null,
            //                 "riskControlFields": null,
            //                 "createTime": null,
            //                 "updateTime": null
            //             },
            //             {
            //                 "id": 147,
            //                 "clientId": 1,
            //                 "clientType": "ios-h5",
            //                 "functionModule": "认证模块",
            //                 "pageCode": "contact_page",
            //                 "pageDes": "contact认证",
            //                 "eventId": "contact_page_enter_button_click",
            //                 "eventDes": "页面提交按钮",
            //                 "eventType": null,
            //                 "dataItem": null,
            //                 "dataItemType": null,
            //                 "dataItemCode": null,
            //                 "dataItemDes": null,
            //                 "riskControlFields": null,
            //                 "createTime": null,
            //                 "updateTime": null
            //             },
            //             {
            //                 "id": 148,
            //                 "clientId": 1,
            //                 "clientType": "ios-h5",
            //                 "functionModule": "认证模块",
            //                 "pageCode": "contact_page",
            //                 "pageDes": "contact认证",
            //                 "eventId": "contact_page_exit_page_tech",
            //                 "eventDes": "退出页面",
            //                 "eventType": null,
            //                 "dataItem": null,
            //                 "dataItemType": null,
            //                 "dataItemCode": null,
            //                 "dataItemDes": null,
            //                 "riskControlFields": null,
            //                 "createTime": null,
            //                 "updateTime": null
            //             }
            //         ],
            //         "thirdName": {
            //             "focus": "contact_page_focus_input_thirdName",
            //             "enter": "contact_page_enter_input_thirdName",
            //             "complete": "contact_page_complete_input_thirdName",
            //             "validate": "contact_page_validate_error_thirdName"
            //         },
            //         "oneName": {
            //             "focus": "contact_page_focus_input_oneName",
            //             "enter": "contact_page_enter_input_oneName",
            //             "complete": "contact_page_complete_input_oneName",
            //             "validate": "contact_page_validate_error_oneName"
            //         },
            //         "twoMobile": {
            //             "focus": "contact_page_focus_input_twoMobile",
            //             "enter": "contact_page_enter_input_twoMobile",
            //             "complete": "contact_page_complete_input_twoMobile",
            //             "validate": "contact_page_validate_error_twoMobile"
            //         }
            //     },
            //     "kyc_page": {
                    
            //         "gender": {
            //             "focus": "kyc_info_focus_input_gender",
            //             "enter": "kyc_info_enter_input_gender",
            //             "complete": "kyc_info_complete_input_gender",
            //             "validate": "kyc_info_validate_error_gender"
            //         },
            //         "panNo": {
            //             "focus": "kyc_info_focus_input_szy_pan_no",
            //             "enter": "kyc_info_enter_input_szy_pan_no",
            //             "complete": "kyc_info_complete_input_szy_pan_no",
            //             "validate": "kyc_info_validate_error_szy_pan_no"
            //         },
            //         "smsCode": {
            //             "focus": "kyc_info_focus_input_szy_sms_code",
            //             "enter": "kyc_info_enter_input_szy_sms_code",
            //             "complete": "kyc_info_complete_input_szy_sms_code",
            //             "validate": "kyc_info_validate_error_szy_sms_code"
            //         },
            //         "back": {
            //             "focus": "kyc_upload_focus_back",
            //             "enter": "kyc_upload_back",
            //             "complete": "kyc_complete_upload_back",
            //             "validate": "kyc_upload_error_back"
            //         },
            //         "idno": {
            //             "focus": "kyc_info_focus_input_szy_idno",
            //             "enter": "kyc_info_enter_input_szy_idno",
            //             "complete": "kyc_info_complete_input_szy_idno",
            //             "validate": "kyc_info_validate_error_szy_idno"
            //         },
                    
            //         "face": {
            //             "focus": "kyc_upload_focus_face",
            //             "enter": "kyc_upload_face",
            //             "complete": "kyc_complete_upload_face",
            //             "validate": "kyc_upload_error_face"
            //         },
                    
            //         "page": [
            //             {
            //                 "id": 39,
            //                 "clientId": 1,
            //                 "clientType": "ios-h5",
            //                 "functionModule": "认证模块",
            //                 "pageCode": "kyc_page",
            //                 "pageDes": "kyc认证",
            //                 "eventId": "kyc_info_enter_button_click",
            //                 "eventDes": "页面提交按钮",
            //                 "eventType": null,
            //                 "dataItem": null,
            //                 "dataItemType": null,
            //                 "dataItemCode": null,
            //                 "dataItemDes": null,
            //                 "riskControlFields": null,
            //                 "createTime": null,
            //                 "updateTime": null
            //             },
            //             {
            //                 "id": 142,
            //                 "clientId": 1,
            //                 "clientType": "ios-h5",
            //                 "functionModule": "认证模块",
            //                 "pageCode": "kyc_page",
            //                 "pageDes": "kyc认证",
            //                 "eventId": "kyc_page_view",
            //                 "eventDes": "进入页面",
            //                 "eventType": null,
            //                 "dataItem": null,
            //                 "dataItemType": null,
            //                 "dataItemCode": null,
            //                 "dataItemDes": null,
            //                 "riskControlFields": null,
            //                 "createTime": null,
            //                 "updateTime": null
            //             },
            //             {
            //                 "id": 143,
            //                 "clientId": 1,
            //                 "clientType": "ios-h5",
            //                 "functionModule": "认证模块",
            //                 "pageCode": "kyc_page",
            //                 "pageDes": "kyc认证",
            //                 "eventId": "kyc_page_enter_button_click",
            //                 "eventDes": "页面提交按钮",
            //                 "eventType": null,
            //                 "dataItem": null,
            //                 "dataItemType": null,
            //                 "dataItemCode": null,
            //                 "dataItemDes": null,
            //                 "riskControlFields": null,
            //                 "createTime": null,
            //                 "updateTime": null
            //             },
            //             {
            //                 "id": 145,
            //                 "clientId": 1,
            //                 "clientType": "ios-h5",
            //                 "functionModule": "认证模块",
            //                 "pageCode": "kyc_page",
            //                 "pageDes": "kyc认证",
            //                 "eventId": "kyc_page_enter_button_click_success",
            //                 "eventDes": "页面提交保存成功",
            //                 "eventType": null,
            //                 "dataItem": null,
            //                 "dataItemType": null,
            //                 "dataItemCode": "",
            //                 "dataItemDes": "",
            //                 "riskControlFields": null,
            //                 "createTime": null,
            //                 "updateTime": null
            //             },
            //             {
            //                 "id": 169,
            //                 "clientId": 1,
            //                 "clientType": "ios-h5",
            //                 "functionModule": "认证模块",
            //                 "pageCode": "kyc_page",
            //                 "pageDes": "kyc认证",
            //                 "eventId": "kyc_exit_page_tech",
            //                 "eventDes": "退出页面",
            //                 "eventType": null,
            //                 "dataItem": null,
            //                 "dataItemType": null,
            //                 "dataItemCode": null,
            //                 "dataItemDes": null,
            //                 "riskControlFields": null,
            //                 "createTime": null,
            //                 "updateTime": null
            //             },
            //             {
            //                 "id": 170,
            //                 "clientId": 1,
            //                 "clientType": "ios-h5",
            //                 "functionModule": "认证模块",
            //                 "pageCode": "kyc_page",
            //                 "pageDes": "kyc认证",
            //                 "eventId": "kyc_szy_exit_page_tech",
            //                 "eventDes": "退出页面",
            //                 "eventType": null,
            //                 "dataItem": null,
            //                 "dataItemType": null,
            //                 "dataItemCode": null,
            //                 "dataItemDes": null,
            //                 "riskControlFields": null,
            //                 "createTime": null,
            //                 "updateTime": null
            //             },
            //             {
            //                 "id": 171,
            //                 "clientId": 1,
            //                 "clientType": "ios-h5",
            //                 "functionModule": "认证模块",
            //                 "pageCode": "kyc_page",
            //                 "pageDes": "kyc认证",
            //                 "eventId": "kyc_page_szy_enter_button_click_success",
            //                 "eventDes": "页面提交保存成功",
            //                 "eventType": null,
            //                 "dataItem": null,
            //                 "dataItemType": null,
            //                 "dataItemCode": "",
            //                 "dataItemDes": "",
            //                 "riskControlFields": null,
            //                 "createTime": null,
            //                 "updateTime": null
            //             },
            //             {
            //                 "id": 172,
            //                 "clientId": 1,
            //                 "clientType": "ios-h5",
            //                 "functionModule": "认证模块",
            //                 "pageCode": "kyc_page",
            //                 "pageDes": "kyc认证",
            //                 "eventId": "kyc_page_szy_enter_button_click",
            //                 "eventDes": "页面提交按钮",
            //                 "eventType": null,
            //                 "dataItem": null,
            //                 "dataItemType": null,
            //                 "dataItemCode": null,
            //                 "dataItemDes": null,
            //                 "riskControlFields": null,
            //                 "createTime": null,
            //                 "updateTime": null
            //             },
            //             {
            //                 "id": 173,
            //                 "clientId": 1,
            //                 "clientType": "ios-h5",
            //                 "functionModule": "认证模块",
            //                 "pageCode": "kyc_page",
            //                 "pageDes": "kyc认证",
            //                 "eventId": "kyc_page_szy_view",
            //                 "eventDes": "进入页面",
            //                 "eventType": null,
            //                 "dataItem": null,
            //                 "dataItemType": null,
            //                 "dataItemCode": null,
            //                 "dataItemDes": null,
            //                 "riskControlFields": null,
            //                 "createTime": null,
            //                 "updateTime": null
            //             }
            //         ],
            //         "front": {
            //             "focus": "kyc_upload_focus_front",
            //             "enter": "kyc_upload_front",
            //             "complete": "kyc_complete_upload_front",
            //             "validate": "kyc_upload_error_front"
            //         },
            //         "email": {
            //             "focus": "kyc_info_focus_input_email",
            //             "enter": "kyc_info_enter_input_email",
            //             "complete": "kyc_info_complete_input_email",
            //             "validate": "kyc_info_validate_error_email"
            //         }
            //     },
            //     "baseinfo_page": {
            //         "education": {
            //             "focus": "kyc_info_focus_input_education",
            //             "enter": "kyc_info_enter_input_education",
            //             "complete": "kyc_info_complete_input_education",
            //             "validate": "kyc_info_validate_error_education"
            //         },
            //         "expenditureOfFamily":{
            //             "focus": "kyc_info_focus_input_expenditureOfFamily",
            //             "enter": "kyc_info_enter_input_expenditureOfFamily",
            //             "complete": "kyc_info_complete_input_expenditureOfFamily",
            //             "validate": "kyc_info_validate_error_expenditureOfFamily"
            //         },
            //         "religion": {
            //             "focus": "kyc_info_focus_input_religion",
            //             "enter": "kyc_info_enter_input_religion",
            //             "complete": "kyc_info_complete_input_religion",
            //             "validate": "kyc_info_validate_error_religion"
            //         },
            //         "marital": {
            //             "focus": "kyc_info_focus_input_marital",
            //             "enter": "kyc_info_enter_input_marital",
            //             "complete": "kyc_info_complete_input_marital",
            //             "validate": "kyc_info_validate_error_marital"
            //         },
            //         "childrenNum": {
            //             "focus": "kyc_info_focus_input_childrenNum",
            //             "enter": "kyc_info_enter_input_childrenNum",
            //             "complete": "kyc_info_complete_input_childrenNum",
            //             "validate": "kyc_info_validate_error_childrenNum"
            //         },
            //         "whatsApp": {
            //             "focus": "base_info_focus_input_whatsApp",
            //             "enter": "base_info_enter_input_whatsApp",
            //             "complete": "base_info_complete_input_whatsApp",
            //             "validate": "base_info_validate_error_whatsApp"
            //         },
                    
            //         "facebook": {
            //             "focus": "base_info_focus_input_facebook",
            //             "enter": "base_info_enter_input_facebook",
            //             "complete": "base_info_complete_input_facebook",
            //             "validate": "base_info_validate_error_facebook"
            //         },
            //         "familyIncome": {
            //             "focus": "base_info_focus_input_familyIncome",
            //             "enter": "base_info_enter_input_familyIncome",
            //             "complete": "base_info_complete_input_familyIncome",
            //             "validate": "base_info_validate_error_familyIncome"
            //         },
                    
            //         "instagram": {
            //             "focus": "base_info_focus_input_instagram",
            //             "enter": "base_info_enter_input_instagram",
            //             "complete": "base_info_complete_input_instagram",
            //             "validate": "base_info_validate_error_instagram"
            //         },
            //         "professional": {
            //             "focus": "base_info_focus_select_professional",
            //             "enter": "base_info_enter_select_professional",
            //             "complete": "base_info_complete_select_professional",
            //             "validate": "base_info_validate_select_professional"
            //         },
            //         "tikTok": {
            //             "focus": "base_info_focus_input_tikTok",
            //             "enter": "base_info_enter_input_tikTok",
            //             "complete": "base_info_complete_input_tikTok",
            //             "validate": "base_info_validate_error_tikTok"
            //         },                    
            //         "instagram1": {
            //             "focus": "base_info_focus_input_instagram1",
            //             "enter": "base_info_enter_input_instagram1",
            //             "complete": "base_info_complete_input_instagram1",
            //             "validate": "base_info_validate_error_instagram1"
            //         },
            //         "page": [
            //             {
            //                 "id": 7,
            //                 "clientId": 1,
            //                 "clientType": "ios-h5",
            //                 "functionModule": "认证模块",
            //                 "pageCode": "baseinfo_page",
            //                 "pageDes": "baseInfo认证",
            //                 "eventId": "base_info_page_view",
            //                 "eventDes": "进入页面",
            //                 "eventType": null,
            //                 "dataItem": null,
            //                 "dataItemType": null,
            //                 "dataItemCode": null,
            //                 "dataItemDes": null,
            //                 "riskControlFields": null,
            //                 "createTime": null,
            //                 "updateTime": null
            //             },
            //             {
            //                 "id": 8,
            //                 "clientId": 1,
            //                 "clientType": "ios-h5",
            //                 "functionModule": "认证模块",
            //                 "pageCode": "baseinfo_page",
            //                 "pageDes": "baseInfo认证",
            //                 "eventId": "base_info_enter_button_click",
            //                 "eventDes": "页面提交按钮",
            //                 "eventType": null,
            //                 "dataItem": null,
            //                 "dataItemType": null,
            //                 "dataItemCode": null,
            //                 "dataItemDes": null,
            //                 "riskControlFields": null,
            //                 "createTime": null,
            //                 "updateTime": null
            //             },
            //             {
            //                 "id": 9,
            //                 "clientId": 1,
            //                 "clientType": "ios-h5",
            //                 "functionModule": "认证模块",
            //                 "pageCode": "baseinfo_page",
            //                 "pageDes": "baseInfo认证",
            //                 "eventId": "base_info_exit_page_tech",
            //                 "eventDes": "退出页面",
            //                 "eventType": null,
            //                 "dataItem": null,
            //                 "dataItemType": null,
            //                 "dataItemCode": null,
            //                 "dataItemDes": null,
            //                 "riskControlFields": null,
            //                 "createTime": null,
            //                 "updateTime": null
            //             }
            //         ],
            //         "email": {
            //             "focus": "base_info_focus_input_email",
            //             "enter": "base_info_enter_input_email",
            //             "complete": "base_info_complete_input_email",
            //             "validate": "base_info_validate_error_email"
            //         }
            //     },
            //     "workinfo_page":{
            //         "payTime": {
            //             "focus": "work_info_focus_input_payTime",
            //             "enter": "work_info_enter_input_payTime",
            //             "complete": "work_info_complete_input_payTime",
            //             "validate": "work_info_validate_error_payTime"
            //         },
            //         "modeOfSalary": {
            //             "focus": "work_info_focus_input_modeOfSalary",
            //             "enter": "work_info_enter_input_modeOfSalary",
            //             "complete": "work_info_complete_input_modeOfSalary",
            //             "validate": "work_info_validate_error_modeOfSalary"
            //         },
            //         "salaryScope": {
            //             "focus": "work_info_focus_input_salaryScope",
            //             "enter": "work_info_enter_input_salaryScope",
            //             "complete": "work_info_complete_input_salaryScope",
            //             "validate": "work_info_validate_error_salaryScope"
            //         },
            //         "workLength": {
            //             "focus": "work_info_focus_input_workLength",
            //             "enter": "work_info_enter_input_workLength",
            //             "complete": "work_info_complete_input_workLength",
            //             "validate": "work_info_validate_error_workLength"
            //         },
            //         "workState": {
            //             "focus": "work_info_focus_select_workState",
            //             "enter": "work_info_enter_select_workState",
            //             "complete": "work_info_complete_select_workState",
            //             "validate": "work_info_validate_error_workState"
            //         },
            //     }
            // }        
            commit('setBuryConfig', config.data)
        },
        bury({ commit }, newBury) {
            newBury['triggerTime'] = dayjs().valueOf()
            bury2([newBury])            
            commit('clearBury')
        },
        buryCache({ commit }, newBury) {
            newBury['triggerTime'] = dayjs().valueOf()
            commit('setburyDelay', newBury)
        },
        uploadBury({ commit,state }) {
            console.log(state.buryCache)
            bury2(state.buryCache)
            commit('clearBuryCache')             
        },
        clearBuryCache({ commit }) {                  
          commit('clearBuryCache')           
        },
        closeToast({ commit }) {
            commit('setToast', false)
        },
        showToast({ commit }) {
            commit('setToast', true)
        },
        setToastTxt({ commit }, txt) {
            commit('setToastTxt', txt)
        },
        clearToken({ commit }) {
            commit('clearToken')
        },        
        setToken( { commit }, token ) {
            commit('setToken', token)                    
            setToken(token)
            setTokenFromStorage(token)
        },
        customLogin2({ commit }, appInfo) {
            return new Promise((resolve, reject) => {
                submitAppInfo2(appInfo.params, appInfo.customHeader).then(response => {
                  if(response.code == 0 ){
                      const { token } = response.data
                      commit('setToken', token)
                      commit('setApp', true)
                      setToken(token)
                      setTokenFromStorage(token)
                      resolve()
                      
                  } else {
                      reject(response.msg)    
                  }   
                }).catch(error => {
                  reject(error)
                })
              })
        },
        customLogin({ commit }, appInfo) {
            return new Promise((resolve, reject) => {
                submitAppInfo(appInfo.params, appInfo.customHeader).then(response => {
                  if(response.code == 0 ){
                      const { token } = response.data
                      commit('setToken', token)
                      commit('setApp', true)
                      setToken(token)
                      setTokenFromStorage(token)
                      
                  } else {
                      reject(response.msg)    
                  }   
                }).catch(error => {
                  reject(error)
                })
              })
        },
        login({ commit }, userInfo) {            
            const { phone, code } = userInfo
            return new Promise((resolve, reject) => {
              login({ phone: '91'+phone.trim(), code: code }).then(response => {
                if(response.code == 0 ){
                    const { token } = response.data
                    commit('setToken', token)
                    commit('setPhone', phone)
                    commit('setApp', false)
                    setToken(token)
                    setPhone(phone)
                    setTokenFromStorage(token)
                    setPhoneFromStorage(phone)
                    resolve({
                        isRegister:response.data.isRegister
                    })
                } else {
                    reject(response.msg)    
                }   
              }).catch(error => {
                reject(error)
              })
            })
          },
    }
})
export default store